import {
  FeaturedIconColor,
  RedoFeaturedIcon,
} from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import TrophyIcon from "@redotech/redo-web/arbiter-icon/trophy-01.svg";
import { Flex } from "@redotech/redo-web/flex";
import { TextAndSupportingText } from "@redotech/redo-web/text-and-supporting-text";
import { JSXElementConstructor, memo } from "react";

export const PopupHeader = memo(function PopupHeader({
  title,
  description,
  Icon = TrophyIcon,
  iconColor = "gray",
}: {
  title: string;
  description?: string;
  Icon?: JSXElementConstructor<any>;
  iconColor?: FeaturedIconColor;
}) {
  return (
    <Flex align="center" dir="row" gap="lg">
      <RedoFeaturedIcon
        color={iconColor}
        Icon={Icon}
        shape="square"
        size="md"
        type="default"
      />
      <TextAndSupportingText
        align="flex-start"
        mainTextSize="sm"
        supportingText={description ?? ""}
        supportingTextSize="xs"
        text={title}
      />
    </Flex>
  );
});
